// muatation types

// store
export const storeModuleLoaded = 'storeModuleLoaded';
export const setIsApp = 'setIsApp';
export const isLoaner = 'isLoaner';
export const sendMessage = 'sendMessage';
export const removeMessage = 'removeMessage';
export const removeAllMessages = 'removeAllMessages';
export const addToMediaObjectMap = 'addToMediaObjectMap';
export const setDatasource = 'setDatasource';
export const setLanguage = 'setLanguage';
export const setStyleUrl = 'setStyleUrl';
export const setStyleLoaded = 'setStyleLoaded';
export const activeCssMode = 'activeCssMode';
export const setBrowserbarColor = 'setBrowserbarColor';
export const setNavigation = 'setNavigation';
export const setViewportSize = 'setViewportSize';
export const setViewportMode = 'setViewportMode';
export const setFontSize = 'setFontSize';
export const setColorMode = 'setColorMode';
export const setImageSize = 'setImageSize';
export const setGlossary = 'setGlossary';
export const setGlossaryTerm = 'setGlossaryTerm';
export const setCalendarEvents = 'setCalendarEvents';
export const setStoreValueByURI = 'setStoreValueByURI';
export const setRootExhibition = 'setRootExhibition';
export const setUrlValidated = 'setUrlValidated';
export const setLandingExhibit = 'setLandingExhibit';
export const setVirtualPackageSyncer = 'setVirtualPackageSyncer';
export const setIsPreviewDataSource = 'setIsPreviewDataSource';
export const setMediaplayer = 'setMediaplayer';

// Content Loading
export const setContentForArticle = 'setContentForArticle';
export const setContentModal = 'setContentModal';

// viewState
export const toggleInViewState = 'toggleInViewState';
export const viewStateSetUiState = 'viewStateSetUiState';

// ScreenReader
export const itIsNoScreenReader = 'itIsNoScreenReader';

// Router
export const routeChanged = 'route/routeChanged';
export const setArticleID = 'setArticleID';
export const setExhibitionID = 'setExhibitionID';
export const setGlossaryTermID = 'setGlossaryTermID';
export const setCalendarEventID = 'setCalendarEventID';
export const setArticleTransition = 'setArticleTransition';
export const swipeIsRouterAction = 'swipeIsRouterAction';

// swipe
export const swipeSetArticleProperties = 'swipeSetArticleProperties';
export const swipeEnableHistory = 'swipeEnableHistory';
export const swipeSetDirection = 'swipeSetDirection';

// AudioPlayer Types
export const audioSetSource = 'audioSetSource';
export const playAugmentedRealityMedia = 'playAugmentedRealityMedia';
export const audioSetState = 'audioSetState';
export const audioSetCurrentTime = 'audioSetCurrentTime';
export const audioStart = 'audioStart';
export const audioStop = 'audioStop';
export const audioTogglePlay = 'audioTogglePlay';
export const audioClose = 'audioClose';
export const audioPause = 'audioPause';
export const resetStartAt = 'resetStartAt';
export const audioSetPlayer = 'audioSetPlayer';
export const audioAutoPlay = 'audioAutoPlay';

// VideoPlayer Types
export const videoSetSource = 'videoSetSource';
export const videoSetState = 'videoSetState';
export const videoSetCurrentTime = 'videoSetCurrentTime';
export const videoStart = 'videoStart';
export const videoStop = 'videoStop';
export const _videoToggle = '_videoToggle';
export const unSetSource = 'unSetSource';
export const videoPause = 'videoPause';
export const videoSetFullScreen = 'videoSetFullScreen';
export const videoSetPlayer = 'videoSetPlayer';
export const setVideoQueue = 'setVideoQueue';

// Gallery
export const gallerySetEntries = 'gallerySetEntries';
export const gallerySetIndex = 'gallerySetIndex';
export const gallerySetSwipeX = 'gallerySetSwipeX';
export const gallerySetFigureProp = 'gallerySetFigureProp';
export const gallerySetHiddenUi = 'gallerySetHiddenUi';
export const gallerySetConfig = 'gallerySetConfig';
export const gallerySetCaptionHeight = 'gallerySetCaptionHeight';

// VrViewr
export const OPEN_VRVIEWER = 'OPEN_VRVIEWER';

// 3dViewer
export const viewer3dSetModel = 'viewer3dSetModel';

// Map
export const mapSetMaps = 'mapSetMaps';

// Custom Map
export const setCustomMapData = 'setCustomMapData';
export const setCustomMapLocationID = 'setCustomMapLocationID';

// Native Mutations
// Native PackageSyncer
export const packageSyncerSetIsSyncerApp = 'packageSyncerSetIsSyncerApp';
export const packageSyncerSetProgress = 'packageSyncerSetProgress';
export const setOfflineAvailablePackages = 'setOfflineAvailablePackages';
export const packageSyncerSetSubPartState = 'packageSyncerSetSubPartState';
export const packageSyncerPushError = 'packageSyncerPushError';
export const packageSyncerClearErrors = 'packageSyncerClearErrors';

// Native System
export const systemSetHeadPhoneState = 'appSetHeadPhoneState';
export const systemSetBatteryState = 'systemSetBatteryState';
export const systemSetBatteryLevel = 'systemSetBatteryLevel';
export const systemSetDeviceInfo = 'systemSetDevicInfo';
export const systemSetAppInfo = 'systemSetAppInfo';

// NativeInterface
export const nativeInterfaceUp = 'nativeInterfaceUp';

// Native Bluetooth
export const bluetoothStart = 'bluetoothStart';
export const bluetoothStop = 'bluetoothStop';
export const bluetoothToggle = 'bluetoothToggle';
export const bluetoothRawScan = 'bluetoothRawScan';
export const bluetoothUpdateRawDetecedBeacons = 'bluetoothUpdateRawDetecedBeacons';
export const bluetoothSetScanConfig = 'bluetoothSetScanConfig';
export const bluetoothSetBeaconDescription = 'bluetoothSetBeaconDescription';
export const bluetoothSetBeaconDescriptionSubset = 'bluetoothSetBeaconDescriptionSubset';
export const bluetoothScanStep = 'bluetoothScanStep';

// Nearest Beacon Algorithm
export const nearestBeaconSetConfig = 'nearestBeaconSetConfig';
export const nearestBeaconSetWinner = 'nearestBeaconSetWinner';
export const nearestBeaconSetWinnerTypeTrigger = 'nearestBeaconSetWinnerTypeTrigger';
export const nearestBeaconSetWinnerRssi = 'nearestBeaconSetWinnerRssi';
export const nearestBeaconPushToWinnerList = 'nearestBeaconPushToWinnerList';
export const nearestBeaconShiftWinnerList = 'nearestBeaconShiftWinnerList';
export const nearestBeaconWinnerOfTypeTrigger = 'nearestBeaconWinnerOfTypeTrigger';
// areaBeaconAlgorithm

export const areaBeaconAlgorithmUpdate = 'areaBeaconAlgorithmUpdate';
export const areaBeaconSetConfig = 'areaBeaconSetConfig';
export const areaBeaconSetDescriptionMap = 'areaBeaconSetDescriptionMap';
// search
export const searchSetData = 'searchSetData';
export const searchQuery = 'searchQuery';

// Native AR-Engine
export const augmentedRealitySetArticle = 'augmentedRealitySetArticle';
export const augmentedRealitySetResult = 'augmentedRealitySetResult';
export const augmentedRealitySetWarningScreenValues = 'augmentedRealitySetWarningScreenValues';
export const arCoreKitSetWarningScreenValues = 'arCoreKitSetWarningScreenValues';

// Tour
export const tourInit = 'tourInit';
export const tourStart = 'tourStart';
export const tourEnd = 'tourEnd';
export const tourNext = 'tourNext';
export const tourPrevious = 'tourPrevious';
export const tourSetCurrent = 'tourSetCurrent';
export const tourSetPosition = 'tourSetPosition';
export const tourSetEntryArticle = 'tourSetEntryArticle';

// Tutorial
export const tutorialInit = 'tutorialInit';
export const tutorialSet = 'tutorialSet';
export const tutorialSetPosition = 'tutorialSetPosition';

// Quiz
export const quizInit = 'quizInit';
export const quizStart = 'quizStart';
export const quizEnd = 'quizEnd';
export const quizStoreResult = 'quizStoreResult';
export const quizCollectQuestions = 'quizCollectQuestions';
export const quizSetArticleToVisited = 'quizSetArticleToVisited';

// Geo Location
export const geoLocationSetCoordinates = 'geoLocationSetCoordinates';
export const getLocationSetHeading = 'getLocationSetHeading';
export const geoLocationInitialize = 'geoLocationInitialize';
export const geoLocationStop = 'geoLocationStop';
export const geoLocationRequestedPermission = 'geoLocationRequestedPermission';

// DEBUG
export const patchState = 'patchState';
export const patchStateByPath = 'patchStateByPath';

// history
export const historyUpdate = 'historyUpdate';
export const historySetCurrentKey = 'historySetCurrentKey';

// scroll
export const scrollSetPosition = 'scrollSetPosition';
export const scrollSetDirection = 'scrollSetDirection';
export const toggleScrolledDown = 'toggleScrolledDown';
export const scrollSavePagePosition = 'scrollSavePagePosition';

// MQTT
export const mqttSuscribeTopic = 'suscribeTopic';
export const mqttUnsuscribeTopic = 'unsuscribeTopic';
export const mqttSetConnected = 'mqttSetConnected';
export const mqttAddToSendBuffer = 'mqttAddToSendBuffer';
export const mqttSetIsWorking = 'mqttSetIsWorking';
export const mqttSetSendBuffer = 'mqttSetSendBuffer';

// Connection
export const connectionSetState = 'connectionSetState';
export const connectionSetBoxxUUID = 'connectionSetBoxxUUID';

// Dmx
export const dmxArticles = 'dmxArticles';

// router
export const setRouteChangedByBrowser = 'setRouteChangedByBrowser';
export const setRouteChangedByClick = 'setRouteChangedByClick';

export const setPageTransitionMode = 'setPageTransitionMode';
